import script from "./ChatMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMessage.vue?vue&type=script&setup=true&lang=ts"

import "./ChatMessage.vue?vue&type=style&index=0&id=e585da5a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e585da5a"]])

export default __exports__